import { Box, makeStyles, Typography } from '@material-ui/core'
import React from 'react'

const useStyles = makeStyles(() => ({
  alignItemsAndJustifyContent: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
}))

type Props = {
  text: string
  height: number
}

export function EmptyChartContainer({
  text,
  height,
}: Props): React.ReactElement {
  const classes = useStyles()

  return (
    <Box className={classes.alignItemsAndJustifyContent} height={height}>
      <Typography variant="h5">{text}</Typography>
    </Box>
  )
}
